<template>
  <div>
    <HeaderNav :overlay="route.meta.overlayHeader === true" :show-menu="route.meta.showMenu !== false" />
    <div style="padding-top:0.8rem">
      <slot />
    </div>

    <!-- Cookie Banner -->
    <div v-if="showCookieBanner" class="cookie-banner">
      <div class="cookie-content">
        <p class="cookie-text">本网站使用 Cookie 技术，用于提升网站访问体验、统计访问数据及优化服务内容。您可通过浏览器设置管理 Cookie 权限，继续使用本网站即视为您同意我们的《Cookie 政策》。</p>
        <div class="cookie-actions">
          <button class="btn-settings" @click="rejectCookies">不接受</button>
          <button class="btn-accept" @click="acceptAllCookies">接受所有Cookie</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HeaderNav from '~/components/HeaderNav.vue'
import { useRoute } from '#imports'
import { ref, onMounted } from 'vue'

const route = useRoute()
const auth = useAuth()

// Cookie Banner Logic
const showCookieBanner = ref(false)

const acceptAllCookies = () => {
  if (process.client) {
    auth.setConsent(true)
    showCookieBanner.value = false
  }
}

const rejectCookies = () => {
  if (process.client) {
    // 不接受时，只在 sessionStorage 中标记，确保当前会话不再弹出
    // 但不持久化，所以下次打开浏览器（新 Session）会再次弹出
    auth.setConsent(false)
    showCookieBanner.value = false
  }
}

onMounted(() => {
  if (process.client) {
    // 优先检查持久化的同意状态
    const consent = auth.getConsent()
    // 如果没有持久化状态，再检查本次会话是否已经做过选择（例如拒绝过）
    const sessionConsent = auth.getSessionReject()
    
    if (!consent && !sessionConsent) {
      showCookieBanner.value = true
    }
  }
})
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 9999;
  padding: 0.4rem 0;
  border-top: 1px solid #eaeaea;
}

.cookie-content {
  width: 100%;
  padding: 0 0.9rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
}

.cookie-text {
  font-size: 0.14rem;
  color: #333;
  line-height: 1.6;
  flex: 1;
}

.cookie-actions {
  display: flex;
  gap: 0.2rem;
  flex-shrink: 0;
  align-items: center;
}

button {
  cursor: pointer;
  font-size: 0.14rem;
  padding: 0.12rem 0.24rem;
  border: 1px solid transparent;
  transition: all 0.3s;
}

.btn-settings {
  background: transparent;
  color: #333;
}
.btn-settings:hover {
  color: #000;
}

.btn-accept {
  background: #111;
  color: #fff;
  border: 1px solid #111;
}

.btn-accept:hover {
  background: #333;
  border-color: #333;
}

@media (max-width: 960px) {
  .cookie-content {
    padding: 0 0.24rem;
    flex-direction: column;
    align-items: stretch;
  }
  
  .cookie-text {
    margin-bottom: 0.2rem;
    text-align: center;
  }
  
  .cookie-actions {
    justify-content: center;
  }
}
</style>
